import React from 'react';

export const BoardMapBackgroundLayer = ({
  background,
  boardWidth,
  offsetX = 0,
  offsetY = 0,
}) => {
  if (!background?.url) {
    return null;
  }

  return (
    <img
      src={background.url}
      alt='Fond de carte'
      draggable={false}
      className='absolute left-0 top-0 select-none pointer-events-none'
      onDragStart={event => event.preventDefault()}
      style={{
        left: offsetX,
        top: offsetY,
        width: Number(background?.width) > 0 ? background.width : boardWidth,
        height: Number(background?.height) > 0 ? background.height : 'auto',
        userSelect: 'none',
        WebkitUserDrag: 'none',
        WebkitUserSelect: 'none',
        opacity: Number.isFinite(background?.opacity)
          ? background.opacity
          : 1,
      }}
    />
  );
};
